export const JSONATA_PATTERN = /(\w|\*\*)+(.\w+)?(\[.*?\w*\])+\w?/g;

/**
 * Returns true if it recognize a jsonata pattern for conditionals. in short
 * if the input contains `[<any word>]`, it will return true.
 * @param {string} input
 */
export const isJSONataConditionalQuery = (input: string) => Boolean(input.match(JSONATA_PATTERN));
